import { Module } from "@/constants";
import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import {
  ReadPayrollDepartment,
  WritePayrollDepartment,
} from "@/types/payrollDepartment";

export const usePayrollDepartmentsDictionary = () => {
  const config = getDictionaryConfig<
    ReadPayrollDepartment,
    WritePayrollDepartment
  >(Module.PayrollDepartments);
  return config;
};
